import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterIdsArraySearchValueObject} from './FilterIdsArraySearchValueObject.js'

export class FilterPriceRankSearchValueObject extends ValueObject {
  #priceRank

  constructor({priceRank}) {
    super()
    this.#priceRank = priceRank
  }

  static create({priceRank}) {
    return new FilterPriceRankSearchValueObject({
      priceRank: FilterIdsArraySearchValueObject.create(priceRank)
    })
  }

  static createWithDefaultValue({config, priceRank}) {
    const {DEFAULT_PRICE_RANK_SEARCH} = config.get('searchFilters')

    return new FilterPriceRankSearchValueObject({
      priceRank: FilterIdsArraySearchValueObject.createForNumbers({
        value: priceRank ?? DEFAULT_PRICE_RANK_SEARCH
      })
    })
  }

  static createQueryParams({config, priceRank}) {
    const {DEFAULT_PRICE_RANK_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterPriceRankSearchValueObject({
      priceRank: QueryParamSharedValueObject.createForPipeArray({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.PRICE_RANK],
        value: priceRank ?? DEFAULT_PRICE_RANK_SEARCH
      })
    })
  }

  get isEmpty() {
    return this.#priceRank.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.isEmpty && {...this.#priceRank.queryParam})
    }
  }

  get value() {
    return this.#priceRank.value
  }

  toJSON() {
    return {
      priceRank: this.#priceRank.toJSON()
    }
  }
}
